export const createIsNativeOfflineAudioContext = (nativeOfflineAudioContextConstructor) => {
    return (anything) => {
        return (nativeOfflineAudioContextConstructor !== null && anything instanceof nativeOfflineAudioContextConstructor);
    };
};
//# sourceMappingURL=/build/es2018/factories/is-native-offline-audio-context.js.map